import React, { Fragment, useContext, useEffect } from 'react';
import Blog from '../../component/Section/Blog';
import { useParams } from 'react-router';
import { SimpleShareButtons } from 'react-simple-share';

import { useAsync } from 'react-use';
import { getNewsDetail } from '../../core/services/news';

import { getImageFullPath } from '../../core';
import { getTopNews } from '../../core/services/news';

import { AppContext } from '../../core/Contexts/AppContext';
import DOMPurify from 'dompurify';

const DetailNews = (props) => {
  const { setTitle, setHeaderType, setImage } = useContext(AppContext);

  useEffect(() => {
    setTitle('სიახლეები');
    setImage('../../images/main-hero.png');
    setHeaderType(1);
  }, [setTitle, setImage, setHeaderType]);

  const params = useParams();

  const details = useAsync(() => getNewsDetail(params.id), [params.id]);

  const news = useAsync(getTopNews, []);

  let content = details?.value?.content;
  if (content) {
    content = content.replaceAll('/uploads/', 'https://msa.gov.ge/uploads/');
  }

  function extractFirstIframeHtml(html) {
    const safeHtml = typeof html === 'string' ? html : '';
    const parser = new DOMParser();
    const doc = parser.parseFromString(safeHtml, 'text/html');
    const iframe = doc.querySelector('iframe');
    if (!iframe) return null;

    const existingStyle = iframe.getAttribute('style') || '';
    const enforcedStyle = 'width:100%;max-width:100%;';
    iframe.setAttribute(
      'style',
      existingStyle ? `${existingStyle}; ${enforcedStyle}` : enforcedStyle
    );

    return iframe.outerHTML;
  }

  function removeIframes(html) {
    const safeHtml = typeof html === 'string' ? html : '';
    const parser = new DOMParser();
    const doc = parser.parseFromString(safeHtml, 'text/html');
    doc.querySelectorAll('iframe').forEach((el) => el.remove());
    return doc.body.innerHTML;
  }

  const iframeHtml = extractFirstIframeHtml(content);
  const contentWithoutIframes = removeIframes(content);

  const sanitizerOptions = {
    ADD_TAGS: ['iframe'],
    ADD_ATTR: [
      'allow',
      'allowfullscreen',
      'frameborder',
      'scrolling',
      'src',
      'title',
      'width',
      'height',
      'style',
    ],
  };

  const sanitizedIframe = iframeHtml
    ? DOMPurify.sanitize(iframeHtml, sanitizerOptions)
    : null;

  const sanitizedContent = DOMPurify.sanitize(
    contentWithoutIframes || '',
    sanitizerOptions
  );

  return (
    <Fragment>
      {!details.loading && (
        <section>
          <div className='container'>
            <div className='text-center mb-5'>
              <h3 className='bold font__size--32 text__32-1024 text-uppercase mb-3'>
                {details.value.title}
              </h3>
            </div>

            <div className='position-relative'>
              <div className='wrapper__sosmed-left d-none d-md-block'>
                <SimpleShareButtons
                  url={window.location.href}
                  whitelist={['Facebook', 'Twitter', 'LinkedIn']}
                  size='30px'
                />
              </div>

              <div className='row justify-content-center'>
                <div className='col-md-10 col-lg-8'>
                  <img
                    src={getImageFullPath(
                      `uploads/news/${details.value.file_name}`
                    )}
                    className='w-100 images__blog-head mb-3'
                    alt=''
                  />
                  {sanitizedIframe && (
                    <div
                      className='video-wrapper mb-3'
                      dangerouslySetInnerHTML={{ __html: sanitizedIframe }}
                    />
                  )}
                  <div className='d-flex align-items-center mb-3'>
                    <h5 className='mb-0 semi-bold font__size--14 text__14-1024 text-uppercase color__blue'>
                      სიახლეები
                    </h5>
                    <span className='font__size--14 text__14-1024 text-uppercase color__gray-1 px-2'>
                      |
                    </span>
                    <h5 className='mb-0 semi-bold font__size--14 text__14-1024 text-uppercase color__gray-1'>
                      {details.value.date}
                    </h5>
                  </div>

                  <div
                    className='normal font__size--16 text__16-1024'
                    dangerouslySetInnerHTML={{ __html: sanitizedContent }}
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      <div className='blog-sec'>
        {!news.loading && <Blog blog={news.value} title={'სიახლეები'} />}
      </div>
    </Fragment>
  );
};

export default DetailNews;
